import bearerToken from "./bearerToken";
import unnecesaryRefresh from "./unnecesaryRefresh";

type Interceptor = (context: any, aborter: AbortController) => any;

const __onRequest: Interceptor[] = [
  // unnecesaryRefresh,
  bearerToken
];

function onRequest(context: any, aborter: AbortController) {
  for (const interceptor of __onRequest) {
    const newContext = interceptor(context, aborter);
    if (newContext) context = newContext;
  }
}

export { onRequest };
export default onRequest;
